// extracted by mini-css-extract-plugin
export default {"skill-tab":"skill-tab_skill-tab__TAHgf","fadeIn":"skill-tab_fadeIn__B7z8H","active":"skill-tab_active__eaq4l"};